import { reactLocalStorage } from 'reactjs-localstorage'

export const checkPermission = (permission = [], every = false) => {
  const {
    access: { permissions = [], permissionGroups = [] } = {},
  } = reactLocalStorage.getObject('user')
  const allPermissions = permissions.concat(permissionGroups)

  return every ?
    permission.every(elem => allPermissions.includes(elem))
    : permission.some(elem => allPermissions.includes(elem))
}
